module.exports = __webpack_public_path__ + "img/strike-a-style_top.80238b80.png";